import React, { useState } from 'react'
import { FolderPlus } from 'lucide-react'
import CreateFolderModal from './CreateFolderModal'

/**
 * New Folder Button Component
 * 
 * Displays a button that opens the create folder modal when clicked.
 * Used in the notes page quick actions section.
 */

const NewFolderButton = () => {
  const [showCreateModal, setShowCreateModal] = useState(false)

  const handleOpenModal = () => {
    setShowCreateModal(true)
  }

  const handleCloseModal = () => {
    setShowCreateModal(false)
  }

  return (
    <>
      <button
        onClick={handleOpenModal}
        className="btn-outline inline-flex items-center justify-center"
        title="Create new folder"
      >
        <FolderPlus className="h-4 w-4 mr-2" />
        New Folder
      </button>

      {showCreateModal && (
        <CreateFolderModal
          isOpen={showCreateModal}
          onClose={handleCloseModal}
        />
      )}
    </>
  )
}

export default NewFolderButton 